import React, { useEffect } from 'react'
import { Button, Stack } from '@mui/material'
import { useCustomTranslation } from '@e3dc-react/shell/Hooks/useCustomTranslation'
import { J2Add } from '@e3dc-react/icons'
import { useInstallationSubDevices } from 'src/Libs/flow/installation/hooks'
import { useActiveInstallationContext, useInstallationConfigurationTabs, useProductSerialnumbers } from 'src/Libs/installations'
import SinglePowerMeterTile from 'src/Libs/installations/components/new-installation/configuration/power-meters/SinglePowerMeterTile'
import { plannedPowerMeterDtoToModelTransformer } from 'src/Libs/installations/api/transformer'
import { PowerMeterSerialNumberReservationProvider } from 'src/Libs/installations/hooks/installation-configuration/power-meters/use-power-meter-serial-number-reservation'

interface Props {
  installationId?: number
}

const PowerMeterOverview: React.FC<Props> = ({ installationId }) => {
  const { t } = useCustomTranslation()
  const { setActiveTab } = useInstallationConfigurationTabs(installationId)
  const { deviceLinks } = useActiveInstallationContext()
  const [newPowerMeter, setNewPowerMeter] = React.useState(false)
  const emcDeviceLink = deviceLinks.find(deviceLink => deviceLink.deviceType === 'emc')
  const emcDeviceLinkId = emcDeviceLink?.id.toString() ?? null

  const [productSerialnumbers] = useProductSerialnumbers(emcDeviceLink?.deviceId ? [emcDeviceLink.deviceId] : undefined)
  const emcSerialnumber = productSerialnumbers[0]?.serialno?.toString() ?? null

  const { data: subDevices, refetch: refetchSubDevices } = useInstallationSubDevices(
    installationId,
    emcDeviceLinkId,
    !!installationId && !!emcDeviceLinkId
  )

  useEffect(() => {
    setActiveTab(3)
  }, []) //eslint-disable-line react-hooks/exhaustive-deps

  const powerMeters =
    subDevices?.monitoring?.meters.flatMap(powermeter => {
      const powerMeter = plannedPowerMeterDtoToModelTransformer(powermeter)
      return powerMeter ? [powerMeter] : []
    }) ?? []

  return (
    <PowerMeterSerialNumberReservationProvider>
      <Stack gap={2}>
        <Button startIcon={<J2Add />} sx={{ alignSelf: 'flex-end' }} onClick={() => setNewPowerMeter(true)} disabled={newPowerMeter}>
          {t('installation-configuration.power-meters.add-button')}
        </Button>
        {newPowerMeter && (
          <SinglePowerMeterTile
            tileKey={'new'}
            installationId={installationId}
            emcDeviceLinkId={emcDeviceLinkId}
            emcSerialnumber={emcSerialnumber}
            allPowerMeters={powerMeters}
            setNewPowerMeter={setNewPowerMeter}
            refetchSubDevices={refetchSubDevices}
          />
        )}
        {powerMeters
          .sort((a, b) => b.id - a.id)
          .map(powermeter => (
            <SinglePowerMeterTile
              key={`powermeter-${powermeter.id}`}
              tileKey={String(powermeter.id)}
              installationId={installationId}
              emcDeviceLinkId={emcDeviceLinkId}
              emcSerialnumber={emcSerialnumber}
              setNewPowerMeter={setNewPowerMeter}
              refetchSubDevices={refetchSubDevices}
              allPowerMeters={powerMeters}
              powerMeter={powermeter}
            />
          ))}
      </Stack>
    </PowerMeterSerialNumberReservationProvider>
  )
}

export default PowerMeterOverview
